import React from "react";
import Layout from "../../../../layout/base/Layout";
import Image from "../../../../common/image/Image";
import { Badge, Col } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import MenuIcon from "../../../../../assets/images/car-solid.svg";
import { useReport } from "../../../../../contexts/ReportContext";
import { useFilter } from "../../../../../contexts/FilterContext";
import { clear_real_quotations } from "../../../../../api/endpoints/quotations";

export default function SellerHeader({
	scrollDirection,
	clientSlug,
	setShowDrawer,
	showDrawer,
	clientPhotoUrl,
}) {
	const {
		checkCarInfoCompleted,
		checkPersonalInfoCompleted,
		checkQuotationInfoCompleted,
		resetForm,
	} = useReport();
	const { resetFilters } = useFilter();
	const location = useLocation();
	const navigate = useNavigate();

	const shouldShowDrawer = location.pathname.includes("quotationProcess");

	return (
		<Layout.LayoutHeader
			justify="space-evenly"
			align="middle"
			scroll={scrollDirection}
		>
			<Col md={2} lg={2} xl={2}></Col>

			<Col md={8} lg={8} xl={8}>
				<div style={{ cursor: "pointer" }} onClick={() => {
					// Limpiar todo el estado para comenzar desde cero
					clear_real_quotations();
					resetForm();
					resetFilters();
					navigate("/");
				}}>
					<Image src={clientPhotoUrl} alt="Logo sistema" height={70} />
				</div>
			</Col>

			<Col md={2} lg={2} xl={2}>
				{shouldShowDrawer && (
					<Layout.HeaderAction
						onClick={() => setShowDrawer(!showDrawer)}
						style={{
							width: "100px",
						}}
					>
						<Layout.HeaderMenuIcon>
							<Layout.HeaderMenuIconContainer>
								<Badge
									count={
										checkCarInfoCompleted() &&
											checkPersonalInfoCompleted() &&
											checkQuotationInfoCompleted()
											? 3
											: checkCarInfoCompleted() && checkPersonalInfoCompleted()
												? 2
												: checkCarInfoCompleted()
													? 1
													: 0
									}
								>
									<Image
										src={MenuIcon}
										alt="Menu"
										style={{
											height: "50%",
											width: "50%",
											marginLeft: "10px",
										}}
									/>
								</Badge>
							</Layout.HeaderMenuIconContainer>
						</Layout.HeaderMenuIcon>
					</Layout.HeaderAction>
				)}
			</Col>
		</Layout.LayoutHeader>
	);
}
